import { Classes } from "@blueprintjs/core";
import classnames from "classnames";
import React from "react";

import { Intent } from "core/components/IntentContext";
import { IViewProps, View } from "core/decorators/View";
import Paragraph from "../typographyView/Paragraph";
import HeadingViewConfig from "./HeadingViewConfig";
import {type} from "os";

export enum HeadingVariant {
	H1 = "h1",
	H2 = "h2",
	H3 = "h3",
	H4 = "h4",
	H5 = "h5",
	H6 = "h6"
}

const headings = Object.values(HeadingVariant);

interface IHeadingViewProps extends IViewProps<HeadingViewConfig, HeadingVariant> {
	autoSkeleton?: boolean; // display in skeleton mode when in Intent == Loading. default = true
}

@View({id: "heading", configClass: HeadingViewConfig, variants: HeadingVariant})
export default class HeadingView extends React.PureComponent<IHeadingViewProps> {

	public render() {
		const { config, children, style, variant, intent, autoSkeleton = true } = this.props;

		const tagName = headings.includes(variant) ? variant : 'div';

		const skeleton = autoSkeleton && Intent.LOADING === intent;

		let wrappedChildren;

		// dont look at it, it scares me
		if(config.wordsPerLine && typeof children === "string") {
			const segments = Array.from({length: config.wordsPerLine}, () => []);
			const parts = children.split(" ");
			let accumulator = 0;
			let cursor = 0;

			for (let i = 0; i < parts.length; i++) {
				accumulator++;

				if(accumulator > config.wordsPerLine) {
					accumulator = 0;
					cursor++;
				}

				segments[cursor].push(parts[i]);
			}

			wrappedChildren = segments.map((words) => <div style={{whiteSpace: "nowrap"}}>{words.join(" ")}</div>);
		}

		return React.createElement(Paragraph, {
			style: {
				...style || {},
				...config.typography || {},
				margin: config.margin,
				padding: config.padding,
				maxWidth: config.maxWidth,
				color: config.color,
				borderBottom: config.separator,
				minHeight: skeleton ? "15px" : "auto"
			},
			tagName,
			config,
			className: classnames({[Classes.SKELETON]: skeleton})
		}, wrappedChildren || children || skeleton && "........");
	}
}



// WEBPACK FOOTER //
// ./src/common/views/heading/Heading.view.tsx